<template>
  <div>
    <!-- signup modal -->
    <OldSignup v-model="modals.oldSignup" @showmodal="showModal($event)" />
    <!-- login form -->
    <LoginForm v-model="modals.loginForm" @showmodal="showModal($event)" />
    <!-- signup Form -->
    <SignupForm v-model="modals.signupForm" @showmodal="showModal($event)" />
    <!-- reset form -->
    <ResetForm v-model="modals.resetForm" @showmodal="showModal($event)" />

    <MainLogIn v-model="modals.mainLogIn" />
    <ResetPassword v-model="modals.resetPassword" />
    <MainRegistration v-model="modals.mainRegistration" />
    <ShareRide v-if="allRide.ride" v-model="modals.shareRide" />
    <CopyPrivateLink v-if="allRide.ride" v-model="modals.copyPrivateLink" />
    <Attraction  v-model="modals.attraction" />
    <UpdateAttractionTime v-if="allRide.ride" v-model="modals.updateAttractionTime" />
    <PleaseAddTheRideToYourList v-model="modals.pleaseAddTheRideToYourList" />
    <PleaseLogInInOrderToEditRide v-model="modals.pleaseLogInInOrderToEditRide" />
    <AreYouShureRemovingAttraction v-model="modals.areYouShureRemovingAttraction" />
    <AreYouShureRemovingDay v-model="modals.areYouShureRemovingDay" />
    <ConfirmRemoveDayWithExtraInfo v-model="modals.confirmRemoveDayWithExtraInfo" />
    <ConfirmForceAddDay v-model="modals.confirmForceAddDay" />
    <ConfirmForceRemoveDay v-model="modals.confirmForceRemoveDay" />
    <ConfirmForceUpdateRideInformation v-model="modals.confirmForceUpdateRideInformation" />
    <MoveDayAttractions v-model="modals.moveDayAttractions" />
    <DoYouWantToAddThisPointToRide v-model="modals.doYouWantToAddThisPointToRide" />
    <DynamicModal v-model="modals.dynamicModal" />
    <LoadingIcon v-model="modals.loadingIcon" />
    <LoadingIconWithUploadStatus v-model="modals.LoadingIconWithUploadStatus" />
    <ExistingAttractionOptions v-model="modals.existingAttractionOptions" />
    <AttractionManagerOptions v-model="modals.attractionManagerOptions" />
    <DayManagerOptions v-model="modals.dayManagerOptions" />
    <UpdateNotification v-model="modals.updateNotification" />
    <ContactForm v-model="modals.contactForm" />
    <InsufficientBalanceModal v-model="modals.insufficientBalanceModal" />
    <MasterAccommodationCompareModal v-model="modals.masterAccommodationCompare" />
    <MasterAttractionCompareModal v-model="modals.masterAttractionCompare" />
    <SaasBusinessBasicAgreementModal v-model="modals.businessBasicAgreement" />
    <UpdatedTermsModal v-model="modals.updatedTerms" />
    <ConfirmDeleteSuggestedAccommodation v-model="modals.confirmDeleteSuggestedAccommodation" />
    <ConfirmRemoveAllAiAttractions v-model="modals.confirmRemoveAllAiAttractions" />
    <ConfirmRemoveAiAccommodation v-model="modals.confirmRemoveAiAccommodation" />
    <ConfirmForceAiRideDateUpdate v-model="modals.confirmForceAiRideDateUpdate" />
    <MyWhatsappNumber v-model="modals.myWhatsappNumber" />
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import AreYouShureRemovingDay from "@/components/Modals/AreYouShureRemovingDay";
import ConfirmRemoveDayWithExtraInfo from "@/components/Modals/ConfirmRemoveDayWithExtraInfo";
import ConfirmForceAddDay from "@/components/Modals/ConfirmForceAddDay";
import ConfirmForceRemoveDay from "@/components/Modals/ConfirmForceRemoveDay";
import ConfirmForceUpdateRideInformation from "@/components/Modals/ConfirmForceUpdateRideInformation";
// import Login from "@/components/Modals/Login";
import OldSignup from "@/components/Modals/OldSignup";
import LoginForm from "@/components/Modals/LoginForm";
import SignupForm from "@/components/Modals/SignupForm";
import ResetForm from "@/components/Modals/ResetForm";
import ShareRide from "@/components/Modals/ShareRide";
import CopyPrivateLink from "@/components/Modals/CopyPrivateLink";
import Attraction from "@/components/Modals/Attraction";
import UpdateAttractionTime from "@/components/Modals/UpdateAttractionTime";
import LoadingIcon from "@/components/Modals/LoadingIcon";
import LoadingIconWithUploadStatus from "@/components/Modals/LoadingIconWithUploadStatus";
import MainLogIn from "@/components/Modals/MainLogIn";
import MainRegistration from "@/components/Modals/MainRegistration";
import PleaseAddTheRideToYourList from "@/components/Modals/PleaseAddTheRideToYourList";
import PleaseLogInInOrderToEditRide from "@/components/Modals/PleaseLogInInOrderToEditRide";
import AreYouShureRemovingAttraction from "@/components/Modals/AreYouShureRemovingAttraction";
import DoYouWantToAddThisPointToRide from "@/components/Modals/DoYouWantToAddThisPointToRide";
import DynamicModal from "@/components/Modals/DynamicModal";
import MoveDayAttractions from "@/components/Modals/MoveDayAttractions";
import ExistingAttractionOptions from "@/components/Modals/ExistingAttractionOptions";
import AttractionManagerOptions from "@/components/Modals/AttractionManagerOptions";
import DayManagerOptions from "@/components/Modals/DayManagerOptions.vue";
import ResetPassword from '@/components/Modals/ResetPassword';
import UpdateNotification from '@/components/Modals/UpdateNotification';
import ContactForm from '@/components/Modals/ContactForm';
import InsufficientBalanceModal from '@/components/Modals/InsufficientBalanceModal.vue';
import MasterAccommodationCompareModal from '@/components/Modals/MasterAccommodationCompareModal.vue';
import MasterAttractionCompareModal from '@/components/Modals/MasterAttractionCompareModal.vue';
import SaasBusinessBasicAgreementModal from '@/components/Modals/SaasBusinessBasicAgreementModal.vue';
import UpdatedTermsModal from '@/components/Modals/UpdatedTermsModal.vue';
import ConfirmDeleteSuggestedAccommodation from '@/components/Modals/ConfirmDeleteSuggestedAccommodation';
import ConfirmRemoveAllAiAttractions from '@/components/Modals/ConfirmRemoveAllAiAttractions';
import ConfirmRemoveAiAccommodation from '@/components/Modals/ConfirmRemoveAiAccommodation';
import ConfirmForceAiRideDateUpdate from '@/components/Modals/ConfirmForceAiRideDateUpdate';
import MyWhatsappNumber from '@/components/Modals/MyWhatsappNumber.vue';

export default {
  name: "PagePopups",
  computed: {
    ...mapGetters(["modals", "allRide", "navigationTarget"]),
  },
  watch: {
    navigationTarget(target) {
      if (target) {
        this.$router.push(target).catch(() => {});
        this.$store.commit('setNavigationTarget', null);
      }
    },
  },
  methods: {
    ...mapActions(["showModal"])
  },
  components: {
    MainLogIn,
    MainRegistration,
    OldSignup,
    LoginForm,
    SignupForm,
    ResetForm,
    ShareRide,
    CopyPrivateLink,
    Attraction,
    UpdateAttractionTime,
    PleaseAddTheRideToYourList,
    PleaseLogInInOrderToEditRide,
    AreYouShureRemovingAttraction,
    AreYouShureRemovingDay,
    ConfirmRemoveDayWithExtraInfo,
    ConfirmForceAddDay,
    ConfirmForceRemoveDay,
    ConfirmForceUpdateRideInformation,
    MoveDayAttractions,
    DoYouWantToAddThisPointToRide,
    DynamicModal,
    LoadingIcon,
    LoadingIconWithUploadStatus,
    ExistingAttractionOptions,
    AttractionManagerOptions,
    DayManagerOptions,
    ResetPassword,
    UpdateNotification,
    ContactForm,
    InsufficientBalanceModal,
    MasterAccommodationCompareModal,
    MasterAttractionCompareModal,
    SaasBusinessBasicAgreementModal,
    UpdatedTermsModal,
    ConfirmDeleteSuggestedAccommodation,
    ConfirmRemoveAllAiAttractions,
    ConfirmRemoveAiAccommodation,
    ConfirmForceAiRideDateUpdate,
    MyWhatsappNumber,
  }
};
</script>
<style scoped>

.light-bg {
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(5px);
}
</style>
